export function forMs<T>(timeout: number): Promise<T> {
    return new Promise(r => setTimeout(r, timeout))
}